import React, {useState} from 'react';
import styles from './reject-registration.module.scss';
import {Row, Col, Button, Spinner} from 'react-bootstrap';
import SuccessModalContent
  from "../../../../../securities/security-details/components/modal-content-success/modal-content-success";
import {
  REGISTRATION_REJECT_ERROR,
  REGISTRATION_REJECT_SUCCESS, REGISTRATION_REJECTED,
  TRADE_REJECT_ERROR,
  TRADE_REJECT_SUCCESS, TRADE_REJECTED,
} from "../../../../../../helpr/constants";
import ErrorModalContent
  from "../../../../../securities/security-details/components/modal-content-error/modal-content-error";
import {useValidation} from "../../../../../../hooks/use-validation";
import {TextInput} from "../../../../../../components/form/form";
import {required} from "../../../../../../helpr/generic-validation-rules";
import SecondaryMarketService from "../../../../../../services/secondary-market-service";

const RejectRegistrationModalContent = ({context, onBack, onClose}) => {
  //Transfer instruction result variables
  const SUCCESS_TITLE = "INVESTOR REGISTRATION REJECTED";
  const ERROR_TITLE = "A PROBLEM OCCURRED";
  const [ page, setPage ] = useState(0);

  //Service call states
  const { selectedRegistration, setRegistrationList } = context;
  const [ loading, setLoading] = useState(false);
  const secondaryMarketService = new SecondaryMarketService();

  //Validator
  const rejectInfoState = useValidation(
    rejectInfoValidator,
    rejectInfoObj({
      rejectReason: ''
    }),
    {border: '1px solid red'});
  const { validate, getTextFieldProps } = rejectInfoState;

  const reject = async () => {
    const { formState, isFormValid } = validate();
    if(!isFormValid){
      return
    }
    setLoading(true);
    try {
      await secondaryMarketService.rejectRegistration(selectedRegistration.current.registrationId, formState);
      setRegistrationList(prev => {
        const updatedList = prev.map(p => {
          if(p.registrationId === selectedRegistration.current.registrationId){
            return {
              ...p,
              registrationStatus: REGISTRATION_REJECTED
            }
          }
          return p
        });
        return updatedList;
      });
      setPage(1);
    }catch(error){
      setPage(2);
    }finally {
      setLoading(false);
    }
  }
  const renderRejectionResult = () => {
    switch(page){
      case 1:
        return <SuccessModalContent title={SUCCESS_TITLE} message={REGISTRATION_REJECT_SUCCESS} onClose={onClose}/>
      case 2:
        return <ErrorModalContent title={ERROR_TITLE} message={REGISTRATION_REJECT_ERROR} onClose={onClose}/>
      default:
    }
  }

  return page === 0 ? (
    <div className={styles['reject-registration-modal-content']}>
      <Row>
        <Col lg={{offset: 1, span: 10}}>
          <Row>
            <Col lg={12}>
              <TextInput inputProps={getTextFieldProps('rejectReason')} placeholder={""} >
                Reason for Rejection
              </TextInput>
            </Col>
          </Row>
          <Row className={styles['button-row']}>
            <Col xs={6} lg={6}>
              <div className={styles['back-button']}>
                <Button variant="secondary" onClick={() => onBack()}>
                  BACK
                </Button>
              </div>
            </Col>
            <Col xs={6} lg={6}>
              <div className={styles['reject-button']}>
                <Button disabled={loading} onClick={() => reject()}>
                  {loading ? <Spinner size="sm" animation="border"/> : 'REJECT'}
                </Button>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  ) : renderRejectionResult()
}

const rejectInfoObj = obj => {
  return {
    fields: {
      rejectReason: {
        value: obj.rejectReason,
        style: {}
      }
    },
    dynamicFields: {}
  }
}

const rejectInfoValidator = {
  fields: {
    rejectReason: [required]
  },
  dynamicFields: {}
}

export default RejectRegistrationModalContent;
